import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import translate from 'src/helpers/translate';
import SubmitButton from 'src/utils/SubmitButton';

export default function AddNewBoardDialog(props){
    const { open, setOpen, onSubmit } = props;
    const [ description, setDescription] = useState(''); 

    const handleClose = () => {
        setOpen(false);
    };

    const submit = () => {
        onSubmit(description);
        setOpen(false);
        setDescription('');
    };

    const handleKeyPress = (event) => {
        if (event.charCode === 13) {
            submit();
        }
    }

    const handleBoardDescriptionChange = (event) => {
        let name = event.target.value;
        setDescription(name);
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{translate('CreateNewBoard')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {translate('PleaseProvideNameForBoard')}
                    </DialogContentText>
                    <TextField
                        autoFocus
                        size="small"
                        id="name"
                        label={translate('Name')}
                        type="string"
                        value={description}
                        onKeyPress={handleKeyPress}
                        onChange={handleBoardDescriptionChange}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={handleClose}
                        color="primary">
                        {translate('Cancel')}
                    </Button>
                    <SubmitButton 
                        isSubmitting={false} 
                        canBeSubmitted={description !== ''} 
                        onSubmit={submit}
                        />
                </DialogActions>
            </Dialog>
        </div>
    );
}